<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 37">
    <path
      d="m9.949 28.686 4.377-.024-.013 2.433-8.534.049.049-8.532 2.434-.012-.024 4.375 6.348-6.348 1.712 1.712-6.348 6.348zM21.183 14.03l6.349-6.349-4.378.025.014-2.435 8.532-.047-.047 8.533-2.434.012.025-4.376-6.35 6.35-1.711-1.713z"
      fill="#FFF"
      fill-rule="nonzero"
    />
  </svg>
</template>
